import React from 'react';
import { Wrapper, SliceZone } from '..';
import './StoryGallery.scss';

const StoryGallery = (props) => {
  const {
    sliceBody,
    siteMetadata,
  } = props;
  return (
    <section className="story-gallery">
      <Wrapper>
        <div className="gallery-container">
          <SliceZone allSlices={sliceBody} siteMetadata={siteMetadata} />
        </div>
      </Wrapper>
    </section>
  );
};

export default StoryGallery;
